export const RESIDENTIAL_MORTGAGE = 'RESIDENTIALMORTGAGES';
export const PERSONALLOANS = 'PERSONALLOANS';
export const DEPOSIT_ACCOUNTS = 'DEPOSITACCOUNTS';
export const CARDS = 'CARDS';
export const CONSUMER_LOAN = 'CONSUMERLOAN';
export const COMMERCIAL = 'COMMERCIAL';
// Small business loans
export const SMALL_BUSINESS = 'SMALLBUSINESS';

export const MERCHANTCASHADVANCES = 'FUNDALOAN';;
export const MORTAGAGE_ACTION_TYPE = 'Mortgage';
export const NOT_MORTAGE_ACTION_TYPE = 'NotMortgage';

// type of financing
export const SECURED = 'Secured';
export const UNSECURED = 'Unsecured';
export const CHECKLINE = 'Checkline';
export const DEPOSIT_ACCOUNT = 'Deposit Accounts';
export const VISA_PLATINUM_CREDIT_CARD = "VISA Platinum Credit Card";
export const VISA_BUSINESS_CREDIT_CARD = "VISA Business Credit Card";
export const VISA_FLEED_CARD = 'VISA Fleet Card';
export const VISA_PURCHASE_CARD = "VISA Purchase";
export const CONSUMER_ACCOUNT = 'Consumer Deposit';
export const BUSINESS_ACCOUNT = 'Business Deposit';
export const SMALL_BUSINESS_LOAN = 'Small Business Loan';
export const COMMERCIAL_LOAN = "Commercial";
export const COMMERCIAL_PURCHASE = 'Commercial Purchase'

export const SECTION_ID = 'driverLicense';
export const SECTION_BANK_STATEMENT = 'bankStatement';
export const SECTION_MONTHLY_INCOME = 'monthlyIncome';
export const SECTION_ANNUAL_INCOME = 'annualIncome';
export const SECTION_TAX_RETURN = 'taxReturn';
export const SECTION_PURCHASE_AGREEMENT = 'purchaseAgreement';
export const SECTION_K1 = 'k1Document';
export const SECTION_ARTICLES_OF_INCORPORATION = 'articlesofIncorporation';
export const SECTION_VOIDED_CHEQUE = 'voidedCheque';
export const SECTION_CREDIT_REPORT = 'creditReport';
export const SECTION_TEAM = 'connectToTeam';
export const SECTION_INVOICE_QUESTION = 'invoiceQuestion';
export const SECTION_INVOICE_STATEMENT = 'invoiceStatement';
export const SECTION_ANNUAL_INCOME_1099 = 'annualIncome1099';
export const SECTION_GREENCARD_DOCUMENT = 'greencardDocument';
export const SECTION_SUMMARY_DEBT_DOCUMENT = 'summaryDebtDocument';

// Products 
export const PURCHASE = 'Purchase';
export const CONSTRUCTION_LOAN = 'Construction';

export const PURCHASE_NEW_HOME = 'Purchasing a new home';
export const REFINANCE = 'Refinance';
export const PRE_QUALIFICATION = 'Prequalification';
export const TERM_LOAN = 'Term Loan';
export const LINE_OF_CREDIT_ALL_CAPS = 'LINE OF CREDIT';
export const TERM_LOAN_ALL_CAPS = 'TERM LOAN';
export const PERSONAL_REVOLVING_LINE_OF_CREDIT = 'Personal Revolving Lines of Credit';
export const CASH_SECURED = 'Cash Secured'
export const HOME_EQUITY = 'Home Equity';
export const HOME_EQUITY_LOAN = 'Home Equity Loan';
export const MORTGAGE_PRODUCTS = [
    PURCHASE,
    HOME_EQUITY,
    REFINANCE,
    CONSTRUCTION_LOAN
]

// Type of product 

export const SINGLE_FAMILY = 'Single family';
export const MULTI_FAMILY = 'Multi family';
export const CONDOMINIUM = 'Condominium';
export const TOWNHOUSE = 'Townhouse';
export const TWO_PROPERTY = 'Two to four unit property';
export const COOPERATIVE = 'Cooperative';
export const MANUFACTURED_HOME = 'Manufactured Home';
export const PUD = 'PUD';
export const HOME = "Home"
export const HOME_EQUITY_TERM = 'Term';
export const HOME_EQUITY_REVOLVING = 'Revolving';
export const HOME_EQUITY_LINE_OF_CREDIT = 'Home Equity Line of Credit';
export const BALLOON_MATURITIES = 'Balloon Maturities';

export const STARTED = 'started';
export const COMPLETED = 'Completed';
export const REJECTED = 'Rejected';
export const INPROGRESS = 'in progress';

export const HOME_REFINANCE = 'Home Refinance';
export const HOME_IMPROVEMENT = 'Home Improvement';
export const CASHOUT_REFINANCE = 'Cash - Out Refinance';
export const OTHER = 'Other';
export const PAYOFF_DEBT = 'Pay off Debt';
export const DEBT_CONSOLIDATION = 'Debt Consolidation';
export const PURCHASE_AUTO = 'Purchase Auto';
export const FINANCE_AUTO = 'Finance Auto';
export const PURCHASE_RV = 'Purchase RV';
export const FINANCE_RV = 'Finance RV';
export const AFFIXED_TO_EXISTING_STRUCTURE = 'Affixed to an Existing Structure';
export const STAND_ALONE_SYSTEM = 'Stand-alone System';
export const PURCHASE_BOAT_TRAILER = 'Purchase Boat/Trailer';
export const FINANCE_BOAT_TRAILER = 'Finance Boat/Trailer';
export const PURCHASE_MOTORCYCLE = 'Purchase Motorcycle';
export const FINANCE_MOTORCYCLE = 'Finance Motorcycle';
export const PERSONAL_EQUIPMENT = 'Personal Equipment';
export const PURCHASE_OTHER_PERSONAL_EQUIPMENT = 'Purchase Other Personal Equipment';
export const PURCHASE_OTHER = 'Purchase Other';
export const PURCHASE_PERSONAL_PROPERTY = 'Purchase Personal Property';
export const MISC = 'Miscellaneous';
export const PERSONAL_PROPERTY = 'Personal Property';
export const CAR_TRUCK_SUV = 'Car, Truck, SUV, etc.';
export const CAR_SUV = 'Car, SUV, etc.';
export const CAR_TRUCK_SUV_MBWI = 'Car, Truck, SUV';
export const MOTOR_HOME = 'Motor Home';
export const RV = 'RV';
export const BOAT_AND_TRAILER_OUTBOARD = 'Boat and Trailer (Outboard Motor)';
export const BOAT_AND_TRAILER_INBOARD = 'Boat and Trailer (Inboard)';
export const BOAT_MOTOR_TRAILER = 'Boat/Motor/Trailer';
export const HAULING_TRAILER = 'Hauling Trailer';
export const OTHER_PERSONAL = 'Other Personal';
export const MOTORCYCLE_ATV_UTV = 'Motorcycle, ATV, UTV, etc.';
export const MOTORCYCLE_ATV_UTV_MBWI = 'Motorcycle, ATV, UTV';
export const ACCOUNTS_RECEIVABLE = 'Accounts Receivable';
export const CASH_VALUE_LIFE_INSURANCE = 'Cash Value Life Insurance'

export const CREDIT_CARD_PAYOFF = 'Credit Card Payoff';
export const LOAN_CONSOLIDATION = 'Loan Consolidation';
export const MOVING_EXPENSES = 'Moving Expenses';
export const MAJOR_PURCHASE = 'Major Purchase';
export const BUSINESS_LOAN = 'Business Loan'
export const SOLAR_LOAN = 'Solar Loan';
export const APPLICANT_AND_CO_APPLICANT_NAME = "Applicant & Co-applicant name";
export const APPLICANT_NAME = "Applicant name";
export const TITLES_OWNED_BY_OTHERS = "Title owned by others";
export const PRIMARY_RESIDENCE = "Primary Residence";
export const PRIMARY = "Primary";
export const SECOND_VACATION_HOME = "Second / Vacation Home";
export const INVESTMENT_RENTAL = "Investment / Rental";
export const INVESTMENT = "Investment";
export const CREDIT_CARD_RATE = 'Introductory Rate';
export const CREDIT_CARD_BONUS = 'Bonus Points';
export const BUY_AN_EXISTING_BUSINESS = 'Buy an existing business';
export const BUYING_OUT_PARTNER = 'Buying out a partner';
export const PURCHASING_EQUIPMENT = 'Purchasing equipment';
export const EXPANSION = 'Expansion';
export const LEASE_INTEREST = 'Lease /mtg. interest';
export const MARKETING_ADVERTISING = 'Marketing / advertising';
export const PAYROLL = 'Payroll';
export const WORKING_CAPITAL = 'Working Capital';
export const REMODEL_LOCATION = 'Remodel location';
export const THINK_ABOUT_BUYING = 'Thinking about buying';
export const LOOKING_FOR_HOME = 'Actively looking for a home';
export const FOUND_THE_HOME = 'I found the home I want to buy';
export const INTREST_ONLY = 'Interest Only';
export const PRINCIPAL_INTREST = 'Principal & Interest'
export const STOCKS_BONDS_BROKERAGE = 'Stocks/Bonds/Brokerage';
export const STOCKS_BONDS_BROKERAGE_WITH_SPACE = 'Stocks/Bonds/ Brokerage';
export const COLLATERAL_REALESTATE = 'Real Estate';


export const COLLATERAL_DEPOSIT_ACCOUNT = 'Deposit Account';
export const MOBILE_HOME = "Mobile Home"

export const CHECKING = 'Checking';
export const SAVINGS = 'Savings';
export const SENIOR_CHECKING = 'Senior Checking';
export const CHECKING_WITH_INTEREST = 'Checking With Interest';
export const RELATIONSHIP_CHECKING = 'Relationship Checking';
export const MONEY_MARKET = 'Money Market';
export const BORROWER_PROFILE = 'profile'